import { registerComponent } from "helpers";

registerComponent(
  "wyatt-accordion",
  class WyattAccordion extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelectorAll("details");

      this.details.forEach((detailsElement) => {
        const summary = detailsElement.querySelector("summary");

        summary.addEventListener("click", this.handleSummaryClick);
        detailsElement.addEventListener(
          "animationend",
          this.handleDetailsClose,
        );
      });
    }

    handleSummaryClick(event) {
      const detailElement = event.currentTarget.closest("details");

      if (detailElement.open) {
        event.preventDefault();
        detailElement.classList.add("closing");
      }
    }

    handleDetailsClose(event) {
      const detailElement = event.currentTarget.closest("details");

      if (event.animationName === "accordion-close") {
        detailElement.removeAttribute("open");
        detailElement.classList.remove("closing");
      }
    }
  },
);
